import { buildQueries } from '../actions/common';
import {
  createDashboardOthersQuery,
  createDashboardQuery,
  getTypeField,
} from '../utils/event/createQueries';
import { toEventResult, toRange } from './eventConverter';
import { addCachedLabel } from './eventApiConverter';

export const createDashboardEventsQueries = (state, unit) => {
  const { events } = unit.compose.events;
  const ids = events.map((event) => event.id);
  const getPeriodsQueries = (event) =>
    event.periodsState.periods
      .filter((period) => !!period.from.length)
      .map((period) => createDashboardQuery(state, unit, event, period));

  const getSplitWithOtherQueries = (event) => {
    const others = event.othersFilter;

    const splitQuery = createDashboardQuery(state, unit, event);
    const othersQuery = createDashboardOthersQuery(state, unit, event, others);
    return [splitQuery, othersQuery];
  };

  const getQueries = (id) => {
    const event = events.find((eventItem) => eventItem.id === id);
    const others = event.othersFilter;
    if (!others) {
      return [createDashboardQuery(state, unit, event)].concat(getPeriodsQueries(event));
    }
    return getSplitWithOtherQueries(event);
  };

  return ids.flatMap((id) => getQueries(id));
};

const getPeriodUniqueChar = (id, periods) =>
  periods
    .map((period, index) => ({
      period,
      uniqueChar: `${index + 1}`,
    }))
    .filter(({ period }) => !!period.from.length)
    .map(({ uniqueChar }) => uniqueChar);

const createDashboardCharArray = (unit) => {
  const { events } = unit.compose.events;
  const ids = events.map((event) => event.id);
  const getSplitWithOthersChar = (id) =>
    !events.find((event) => event.id === id).othersFilter
      ? []
      : `${events.find((event) => event.id === id).uniqueChar}.Others`;

  return ids.flatMap((id) =>
    [events.find((event) => event.id === id).uniqueChar]
      .concat(
        getPeriodUniqueChar(id, events.find((event) => event.id === id).periodsState.periods).map(
          (c) => `${events.find((event) => event.id === id).uniqueChar}${c}`
        )
      )
      .concat(getSplitWithOthersChar(id))
  );
};

export const getDashboardEventsInfo = (state) => {
  const getType = (field) => getTypeField(field, state);

  return { getType };
};

export const eventsDashboardResponseMapper = (response, queries, dashboardEventsInfo, unit) => {
  const { getType } = dashboardEventsInfo;
  const charsArray = createDashboardCharArray(unit);
  const isEventsWithOthers =
    charsArray.length > 1 && charsArray.some((char) => char.includes('Others'));
  const result = response
    .map((resultItem, index) =>
      toEventResult(resultItem, queries[index], charsArray[index], getType, isEventsWithOthers)
    )
    .map((resultItem, index) =>
      !response[index].cached ? resultItem : addCachedLabel(resultItem)
    );
  const options = toRange(result[0].info);
  return {
    result,
    options,
    unit,
  };
};

export const buildDashboardEventQueries = (state, unit) =>
  buildQueries(state, createDashboardEventsQueries, unit);
